import React,{useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input,} from 'antd';
import { useBnsBanBenUpdateQuery, useBnsBanBenUpdateSaveMutation } from '../../store/BnsKeJiApi';
import { EditOutlined } from '@ant-design/icons';
import ModuleSelect from '../module/ModuleSelect';
const {TextArea} = Input
function SubmoduleEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bbb_xuzhi:'',
        bbb_jihua:''
    }); 
    const {data,isSuccess} = useBnsBanBenUpdateQuery({bbb_id:props.bbb_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bbb_name:data.Result.bbb_name,
                    bbb_xuzhi:data.Result.bbb_xuzhi,
                    bbb_jihua:data.Result.bbb_jihua,
                    bbb_bg_id:[data.Result.bbb_bg_id],
                    bbb_bgn_id:[data.Result.bbb_bgn_name],
                    bbb_dept_id:[data.Result.bbb_dept_id],
                    bbb_bgn_name:data.Result.bbb_bgn_name,
                })
                setInfo(prevState=>({...prevState,
                    bbb_name:data.Result.bbb_name,     
                    bbb_xuzhi:data.Result.bbb_xuzhi,
                    bbb_jihua:data.Result.bbb_jihua,                
                    bbb_bg_id:data.Result.bbb_bg_id,                
                    bbb_bg_name:data.Result.bbb_bg_name,                
                    bbb_bgn_id:data.Result.bbb_bgn_id,                
                    bbb_bgn_name:data.Result.bbb_bgn_name,                
                    bbb_dept_id:data.Result.bbb_dept_id,                
                    bbb_dept_name:data.Result.bbb_dept_name,                
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsBanBenUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改子模块</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改子模块'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bbb_e_id" : localStorage.getItem('e_id'),
                        "bbb_dept_id" : '540',
                        "bbb_dept_name" : '开发部',
                        "bbb_bg_id" : info.bbb_bg_id,
                        "bbb_bg_name" : info.bbb_bg_name,
                        "bbb_name" : info.bbb_name,   
                        bbb_xuzhi:info.bbb_xuzhi,
                        bbb_jihua:info.bbb_jihua,
                        "bbb_uid" :localStorage.getItem('eu_id'),
                        "bbb_uname" : localStorage.getItem('eu_name'), 
                        "bbb_id" : props.bbb_id,     
                        "bbb_bgn_id" : info.bbb_bgn_id,                                    
                        "bbb_bgn_name" : info.bbb_bgn_name,                     
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.bbb_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <ModuleSelect
                        bgn_bg_id={info.bbb_bg_id}
                        label='模块'
                        name='bbb_bgn_name'
                        wrapperCol={{span:15}}
                        required
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bbb_bgn_id:e,bbb_bgn_name:f.label}))
                        }}
                        style={{width:"200px"}}
                    />
                    <Form.Item name="bbb_name" label='子模块名称' wrapperCol={{span:10}} required>
                        <Input   onChange={(e) => {setInfo(prevState=>({...prevState,bbb_name:e.target.value}))}}/>
                    </Form.Item> 
                     <Form.Item 
                        name="bbb_xuzhi" 
                        label='子模块说明' 
                        wrapperCol={{span:20}}                         
                    >
                        <TextArea 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bbb_xuzhi:e.target.value}))}}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default SubmoduleEdit